import { atom } from "jotai";
import { nodesAtom } from "../nodes";
import { edgesAtom } from "../edges";
import { saveCanvasSetter } from "./saveCanvasSetter";

/**
 * Setter atom that saves the current nodes and edges to the backend.
 * This is useful when you need to persist the current state of the canvas
 * without having specific nodes/edges variables in scope (e.g., in callbacks).
 *
 * Usage:
 * ```ts
 * const saveCurrentNodesAndEdges = useSetAtom(saveCurrentNodesAndEdgesSetter);
 *
 * await saveCurrentNodesAndEdges();
 * ```
 */
export const saveCurrentNodesAndEdgesSetter = atom(null, async (get, set) => {
  const nodes = get(nodesAtom);
  const edges = get(edgesAtom);

  return await set(saveCanvasSetter, { nodes, edges });
});

saveCurrentNodesAndEdgesSetter.debugLabel = "saveCurrentNodesAndEdgesSetter";
